module.exports = {"341622001":"漆园街道","341622002":"庄周街道","341622003":"城关街道","341622101":"双涧镇","341622102":"小涧镇","341622104":"坛城镇","341622106":"许疃镇","341622107":"板桥集镇","341622108":"马集镇","341622109":"岳坊镇","341622110":"立仓镇","341622111":"楚村镇","341622112":"乐土镇","341622113":"三义镇","341622114":"篱笆镇","341622201":"王集乡","341622202":"小辛集乡","341622400":"安徽蒙城经济开发区管理委员会","341622401":"淮北矿业集团有限责任公司许疃煤矿"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341622.json
// module id = 1254
// module chunks = 0